
export const isConnectionSuccessful = (status) => {
  return status >= 200 && status < 300;
};
